var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sports-page" },
    [
      _c(
        "v-layout",
        { staticClass: "page-layout" },
        [
          _c(
            "v-flex",
            {
              ref: "maincolumn",
              staticClass: "main-column",
              style: { paddingTop: _vm.headerHeight + "px" }
            },
            [
              _c("div", { staticClass: "trnpagewrap" }, [
                _c("h1", [_vm._v("Translator toolbox")]),
                _vm._v("\n        Translations state:"),
                _c("br"),
                _vm._v("\n        language = "),
                _c("b", [_vm._v(_vm._s(_vm.lang))]),
                _vm._v("     brand = "),
                _c("b", [_vm._v(_vm._s(_vm.brand))]),
                _vm._v("     "),
                _c(
                  "a",
                  { attrs: { href: _vm.brandDictionaryUrl, target: "_blank" } },
                  [_vm._v("brand dict file")]
                ),
                _c("br"),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm.isLoadingData
                  ? _c(
                      "div",
                      [
                        _c("loader"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n          Loading translation dictionaries and calculating stats\n        "
                        )
                      ],
                      1
                    )
                  : _vm.dictBase !== null
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          class: {
                            "v-btn v-btn--has-bg theme--light v-size--default": true,
                            primary: _vm.activeTab == "stats"
                          },
                          on: {
                            click: function($event) {
                              return _vm.switchTab("stats")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "v-btn__content" }, [
                            _vm._v("Show Statistics")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: {
                            "v-btn v-btn--has-bg theme--light v-size--default": true,
                            primary: _vm.activeTab == "dictdiff-merged"
                          },
                          on: {
                            click: function($event) {
                              return _vm.compareDicts("merged")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "v-btn__content" }, [
                            _vm._v("All (base + new + changed) phrases")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: {
                            "v-btn v-btn--has-bg theme--light v-size--default": true,
                            primary: _vm.activeTab == "dictdiff-new"
                          },
                          on: {
                            click: function($event) {
                              return _vm.compareDicts("new")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "v-btn__content" }, [
                            _vm._v("New phrases")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: {
                            "v-btn v-btn--has-bg theme--light v-size--default": true,
                            primary: _vm.activeTab == "dictdiff-changed"
                          },
                          on: {
                            click: function($event) {
                              return _vm.compareDicts("changed")
                            }
                          }
                        },
                        [_vm._v("Changed phrases")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: {
                            "v-btn v-btn--has-bg theme--light v-size--default": true,
                            primary: _vm.activeTab == "dictdiff-all"
                          },
                          on: {
                            click: function($event) {
                              return _vm.compareDicts("all")
                            }
                          }
                        },
                        [_vm._v("New + Changed phrases")]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.activeTab == "stats"
                        ? _c("div", [
                            _vm._v("\n            Dictionary stats:"),
                            _c("br"),
                            _vm._v(
                              "\n            base dictionary: " +
                                _vm._s(_vm.dictStats.basePhraseCount)
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            override dictionary (static translations file): " +
                                _vm._s(_vm.dictStats.ovrdPhraseCount)
                            ),
                            _c("br"),
                            _vm._v(
                              "            \n            new phrases (exist only in static's file): " +
                                _vm._s(_vm.dictStats.ovrdPhraseNewCount)
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            chaged phrases (same key, different text in static's file): " +
                                _vm._s(_vm.dictStats.ovrdPhraseChangedCount)
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            overriden phrases (new or changed phrases from static's file): " +
                                _vm._s(_vm.dictStats.ovrdPhraseNewCount) +
                                " + " +
                                _vm._s(_vm.dictStats.ovrdPhraseChangedCount) +
                                " = " +
                                _vm._s(_vm.dictStats.ovrdPhraseOverrideCount)
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            duplicate phrases (same phrases in both base and static's file): " +
                                _vm._s(_vm.dictStats.ovrdPhraseDuplicateCount)
                            ),
                            _c("br"),
                            _c("br"),
                            _c("br"),
                            _vm._v(" "),
                            _c("div", { staticClass: "tdiagram" }, [
                              _c("div", { staticClass: "dstep" }, [
                                _c("div", { staticClass: "ddata" }, [
                                  _c("div", { staticClass: "dtitle" }, [
                                    _vm._v("Base translations")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "dnums" }, [
                                    _vm._v(
                                      _vm._s(_vm.dictStats.basePhraseCount)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ddata" }, [
                                  _c("div", { staticClass: "dtitle" }, [
                                    _vm._v("Brand translations")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "dnums" }, [
                                    _vm._v(
                                      _vm._s(_vm.dictStats.ovrdPhraseCount)
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sum-down" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "dstep" }, [
                                _c(
                                  "div",
                                  { staticClass: "dnote with-arrow-down" },
                                  [
                                    _vm._v(
                                      "\n                Base and Brand translations are mixed at app/website start\n                "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "dstep" }, [
                                _c("div", { staticClass: "ddata" }, [
                                  _c("div", { staticClass: "dtitle" }, [
                                    _vm._v("Active translations")
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "dnums" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dictStats.basePhraseCount +
                                          _vm.dictStats.ovrdPhraseNewCount
                                      )
                                    )
                                  ])
                                ])
                              ])
                            ])
                          ])
                        : _vm.activeTab == "dictdiff-merged" ||
                          _vm.activeTab == "dictdiff-new" ||
                          _vm.activeTab == "dictdiff-changed" ||
                          _vm.activeTab == "dictdiff-all"
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "dict-to-text" },
                              [
                                _vm._v("\n              {\n                "),
                                _vm._l(_vm.dictDiff, function(
                                  phraseText,
                                  phraseKey,
                                  phraseIx
                                ) {
                                  return _c(
                                    "div",
                                    { key: phraseKey },
                                    [
                                      _vm._v(
                                        '"' +
                                          _vm._s(phraseKey) +
                                          '": "' +
                                          _vm._s(
                                            phraseText.replaceAll('"', '\\"')
                                          ) +
                                          '"'
                                      ),
                                      phraseIx <
                                      Object.keys(_vm.dictDiff).length - 1
                                        ? [_vm._v(",")]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                }),
                                _vm._v("\n              }\n            ")
                              ],
                              2
                            )
                          ])
                        : _vm._e()
                    ])
                  : _c("div", [
                      _c(
                        "button",
                        {
                          staticClass:
                            "v-btn v-btn--has-bg theme--light v-size--default",
                          on: {
                            click: function($event) {
                              return _vm.loadDictionaries()
                            }
                          }
                        },
                        [_vm._v("load diciotnaries & shows stats")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n          Load translation dictionaries and see stats and diffs."
                      ),
                      _c("br"),
                      _vm._v(
                        '\n          Once loaded use "Show New + Changed" to create overriding dicitonary for lang + brand.\n        '
                      )
                    ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a700551", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a700551","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ToolboxTranslatorPage.vue
// module id = null
// module chunks = 